import { Button, FormControl, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import { RequirementStatus } from '../../Common/FieldsForForms/RequirementStatus'
import { Plus } from 'react-feather'
import { DepositTable } from './DepositTable'

export const ContractTermination = ({ useFetchInit }) => {

  const {
    //------------- Generales
    location,
    paramsURL,
    //------------- globalStates
    globalStates,
    //------------- FetchData
    FetchData,
    //------------- Actions
    Actions,
    //------------- helpers
    Helpers,
    //------------- Formularios
    Forms

  } = useFetchInit

  const { FormRequestGlobal: { formState, onInputChange } } = Forms

  const { formOpeningMode } = globalStates

  const { handleClickShowModal } = Actions


  return (
    <>
      <Typography sx={{ mt: 3, fontWeight: 'bold' }} variant='subtitle2'>
        Requisitos para la finalizacion de credito
      </Typography>
      <div className="border-bottom border-dark"></div>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 4 }}>


        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
          <RequirementStatus message='1. El cliente debe estar solvente en su totalidad' requirement_status={formState.check_requerimiento_solvent} />
        </Grid>

        {(formState.clean_gps > 0) && (
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
            <RequirementStatus message='2. El cliente debe de realizar el retiro de GPS' requirement_status={formState.check_requerimiento_gps} />
          </Grid>
        )}

        {(formState.clean_seguro > 0) && (
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
            <RequirementStatus message='3. El cliente debe de haber cancelado la poliza de seguro' requirement_status={formState.check_requerimiento_seguro} />
          </Grid>
        )}

      </Grid>

      <Typography sx={{ mt: 3, fontWeight: 'bold' }} variant='subtitle2'>
        Pago de finiquito
      </Typography>
      <div className="border-bottom border-dark"></div>

      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
        <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
          <FormControl fullWidth>
            <label htmlFor="costo_finiquito">Costo Finiquito (Q)</label>
            <TextField
              id='costo_finiquito'
              name='costo_finiquito'
              value={formState.costo_finiquito}
              onChange={onInputChange}
              size='small'
              placeholder='costo de retiro'
              type='text'
              variant='filled'
              InputProps={{
                readOnly: true
              }}

            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
          <FormControl fullWidth>
            <label htmlFor="total_gastos_admin">Gastos Administrativos (Q)</label>
            <TextField
              id='total_gastos_admin'
              name='total_gastos_admin'
              value={formState.total_gastos_admin}
              onChange={onInputChange}
              size='small'
              placeholder='Gastos Administrativos'
              type='text'
              variant='filled'
              InputProps={{
                readOnly: true
              }}

            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 1, mt: 2 }}>
          <FormControl fullWidth>
            <label htmlFor="total_gastos_juridicos">Gastos Juridicos (Q)</label>
            <TextField
              id='total_gastos_juridicos'
              name='total_gastos_juridicos'
              value={formState.total_gastos_juridicos}
              onChange={onInputChange}
              size='small'
              placeholder='Gastos Juridicos'
              type='text'
              variant='filled'
              InputProps={{
                readOnly: true
              }}

            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2, }}>
          <FormControl fullWidth>
            <label htmlFor="butto_payment">Pago</label>
            <Button
              startIcon={<Plus />}
              variant='contained'
              sx={{ marginBottom: 4 }}
              color='primary'
              onClick={() => handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'EDITABLE')}
              disabled={(formOpeningMode === 'READONLY') ? true : false}
            >
              Agregar Pago
            </Button>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
          <FormControl fullWidth>
            <DepositTable useFetchInit={useFetchInit} />
          </FormControl>
        </Grid>
      </Grid>
    </>
  )
}